{
  "version": 1,
  "asset_id": "0c5dcdfb-64dc-45d0-a702-f5fb382c838d",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/0c5dcdfb-64dc-45d0-a702-f5fb382c838d/hernando-galvalume-metal-roof-aerial-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/0c5dcdfb-64dc-45d0-a702-f5fb382c838d/hernando-galvalume-metal-roof-aerial-1320w.webp",
  "original_filename": "hernando-galvalume-metal-roof-aerial-1320w.webp",
  "size": 161706,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
